import { MoneyApi } from "go-core/api/types";
import { ImageLinkApi } from "go-security/services/Api/typesSecurity";
import { OrderPreparationStatusName } from "../Organization/types";
import { AddressApi, CoordinatesApi } from "../types";

export enum PaymentStatus {
	OPEN = "OPEN",
	PAID = "PAID",
	WAIT_TO_PAY = "WAIT_TO_PAY",
}

export enum OrderType {
	DELIVERY = "DELIVERY",
	DINE_IN = "DINE_IN",
	ROOM_SERVICE = "ROOM_SERVICE",
	PICK_UP = "PICK_UP",
}

export interface OrderTaxItemData {
	total_price_net: MoneyApi;
	total_price_tax: MoneyApi;
	total_price_gross: MoneyApi;
	tax_amount: number;
	tax_code: string;
}

export interface OrderItemData {
	quantity: number;
	unit_price: MoneyApi;
	total_price: MoneyApi;
	sub_total_price: MoneyApi;
	comment?: string;
	product?: {
		name: string;
	};
}

export interface OrderCompanyData {
	name?: string;
	public_name?: string;
	tax_id_no?: string;
	address?: AddressApi;
	facebook?: string;
	instagram?: string;
	website?: string;
	logo_link?: {
		default_link?: string;
		small?: string;
	};
	coordinates?: CoordinatesApi;
}

export enum PaymentReceiptType {
	CASH = "CASH",
	CARD = "CARD",
	CHECK = "CHECK",
	BOND = "BOND",
	CREDIT = "CREDIT",
	OTHER = "OTHER",
	VOUCHER = "VOUCHER",
	CLIENT_ACCOUNT = "CLIENT_ACCOUNT",
	BANK_TRANSFER = "BANK_TRANSFER",
}

export interface PaymentMethod {
	id: string | number;
	name: string;
	receipt_type: PaymentReceiptType;
}

export interface Transaction {
	price: MoneyApi;
	tender_price: MoneyApi;
	change_price: MoneyApi;
	status: PaymentStatus;
	payment_method: PaymentMethod;
	paid_at?: string;
}

export interface OrderEmployee {
	name: string;
	accept_tips: boolean;
	avatar_link?: ImageLinkApi;
}

export interface OrderDetailsData {
	number: string;
	total_price: MoneyApi;
	to_pay: MoneyApi;
	total_price_tax: MoneyApi;
	payment_status: PaymentStatus;
	order_at?: string;
	closed_at?: string;
	discount_price?: MoneyApi;
	items?: OrderItemData[];
	tax_items: OrderTaxItemData[];
	source?: {
		number?: string;
	};
	transactions?: Transaction[];
	employee?: OrderEmployee;
	tip?: MoneyApi;
	payment_methods: OrderPaymentMethodApi[];
	delivery?: OrderDeliveryData;
	preparation_status_changes?: OrderPreparationStatusChangesData;
	e_receipt: boolean;
	payment_online_in_progress: boolean;
	table?: OrderTableApi;
	type: OrderType;
	tip_available: boolean;
	online_payment_enabled: boolean;
	google_merchant_id?: string;
	sub_total_price: MoneyApi;
	tax_id_no?: string;
	invoice_public_id?: string;
	payment_online_in_progress_type?: string;
	apple_pay_on_site: boolean;
}

export interface OrderTableApi {
	name?: string;
	room_name?: string;
}

export interface OrderPaymentMethodApi {
	type: OrderPaymentMethodType;
	id: number;
}

export interface OrderData extends OrderDetailsData {
	company?: OrderCompanyData;
}

export interface NumberOrderApi {
	id: number;
	created_at: string;
	status: OrderPreparationStatusName;
	order_number: string;
}

export interface NumberOrderOrganizationInfoApi {
	company: {
		address: AddressApi;
		name: string;
		public_name: string;
		ax_id_no: string;
		website: string;
		logo_link?: ImageLinkApi;
	};
	font_size: number;
}

export enum OrderPaymentMethodType {
	BLIK = "BLIK",
	APPLE_PAY = "APPLE_PAY",
	GOOGLE_PAY = "GOOGLE_PAY",
	BANK_TRANSFER = "BANK_TRANSFER",
}

export enum OrderTransactionStatus {
	SUCCESS = "SUCCESS",
	ERROR = "ERROR",
	NEW = "NEW",
}

export interface OrderTransactionApi {
	id?: string;
	status?: OrderTransactionStatus;
	success_redirect_url?: string;
	error_redirect_url?: string;
	redirect_url?: string;
	in_progress: boolean;
}

export interface OrderDeliveryData {
	address?: AddressApi;
	coordinates: CoordinatesApi;
	delivery_employee?: {
		coordinates: CoordinatesApi;
	};
	delivery_at?: string;
}

export interface OrderPreparationStatusChangesData {
	created_at?: string;
	accepted_at?: string;
	in_progress_at?: string;
	ready_at?: string;
	packed_at?: string;
	received_at?: string;
	delivered_at?: string;
	delivered_supported: boolean;
	in_progress_supported: boolean;
	packed_supported: boolean;
	ready_supported: boolean;
	received_supported: boolean;
}

export interface PayOrderData {
	payment_data: string;
	payment_method_type: OrderPaymentMethodType;
	amount: number;
	payment_method_id: number;
	email: string;
	success_redirect_url?: string;
	error_redirect_url?: string;
	tax_id_no?: string;
	blikToken?: number;
	tip_amount?: number;
}
